module.exports = __webpack_public_path__ + "assets/img/mask-bg1.ea848569.png";